import Vue from 'vue'

console.log('??? running bootstrap.js');

//////////////////////////////////////////

// function initSlug() {
//     let p = window.location.pathname.split('/');
//     //note: first split p[0] is always ""
//     // /restaurant/slug
//     return p[2];
// }

// export const slug = '' + initSlug();
// export const appId = 'otg';

//////////////////////////////////////////////////

export const host = window.location.host; //with port
export const hostNoPort = window.location.hostname; //without port

// function getWildcardDomain() {
//     let domain = hostNoPort;
//     if (domain.indexOf('kikis-deko-und-aromashop.de') > 0) {
//         domain = '.kikis-deko-und-aromashop.de';
//     }
//     // if (domain.indexOf('qsignal.eu') > 0) {
//     //     domain = '.qsignal.eu';
//     // }
//     return domain;
// }
//
// let _wildcardDomain = getWildcardDomain();
// export const wildcardDomain = '' + _wildcardDomain;

/////////////////////////////////////////
function generateClientId() {
    return Math.random().toString(36).substring(2)
        + (new Date()).getTime().toString(36);
}

let btaste = '' + Date.now();

export function initbtaste() {
    try {
        let taste = Vue.ls.get('btaste'); // => undefined
// if (!uid || !Cookies.get('profileConsent')) {
// var firstTime = false;
        let _taste = taste;
        console.log('debugtaste: ls.get: ' + taste);
        if (!taste || taste.length < 25 || _taste.lastIndexOf('-') === -1) {
            console.log('debugtaste: if=true');
            let a = generateClientId();
            let b = Date.now() * 2;
            let _btaste = a + '-' + b;
            _taste = hostNoPort + _btaste;
            btaste = _taste;
            Vue.ls.set('btaste', btaste);
            console.log('debugtaste: ls.set: ' + btaste);
            // let exp = 365 * 24 * 60 * 60 * 1000;//expiry 30 minutes

            // Cookies.set('uid', _uid, {domain: host, path: '/', expires: 360, secure: true});
            // location.replace(pagesUrl + '/exit/one.html');
        } else {
            console.log('debugtaste: if=false');
        }

        //FIXME enable this random suffix when the node is prepared
        // //always replace the random id at the and of btaste
        // let pf = _taste.substring(0, _taste.lastIndexOf('-'));
        // let b = Date.now() * 2;
        // btaste = pf + '-' + b;
        // Vue.ls.set('btaste', btaste);

    } catch (e) {
        // console.log('debugtaste: error in init btaste: ', e);
        //retry
        setTimeout(() => {
            initbtaste();
        }, 50);
    }
}

initbtaste();

export function getBtaste() {
    try {
        let taste = Vue.ls.get('btaste');
        if (taste && taste !== btaste) {
            console.log('debugtaste: repair btaste to ' + taste);
            btaste = taste;
        }
    } catch (e) {

    }
    return btaste;
}


export function hasAccount() {
    let acc = Vue.ls.get('hasAccount', false);
    // let hasAcc = acc !== null &&  acc === 'true';
    return acc === true || acc === 'true';
}


//////////////////////////////

// function detectAndroid() {
//     let userAgent = navigator.userAgent || navigator.vendor || window.opera;
//
//     // if( userAgent.match( /iPad/i ) || userAgent.match( /iPhone/i ) || userAgent.match( /iPod/i ) )
//     // {
//     //     return 'ios';
//     // }
//     if (userAgent.match(/Android/i)) {
//         // return 'android';
//         return true;
//     }
//     // else
//     // {
//     //     return 'unknown';
//     // }
//     return false;
// }
// let _isAndroid = detectAndroid();
// export const isAndroid = _isAndroid;
//////////////////////////////


